import React, { useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { Box, TextField } from "@mui/material";

export const SelectPaises = () => {
	const countriese = [
		{ code: "AD", label: "Andorra", phone: "376" },
		{ code: "AE", label: "United Arab Emirates", phone: "971" },
		{ code: "AF", label: "Afghanistan", phone: "93" },
		{ code: "AG", label: "Antigua and Barbuda", phone: "1-268" },
		{ code: "AI", label: "Anguilla", phone: "1-264" },
		{ code: "AL", label: "Albania", phone: "355" },
		{ code: "AM", label: "Armenia", phone: "374" },
		{ code: "AO", label: "Angola", phone: "244" },
		{ code: "AQ", label: "Antarctica", phone: "672" },
		{ code: "AR", label: "Argentina", phone: "54" },
		{ code: "AS", label: "American Samoa", phone: "1-684" },
		{ code: "AT", label: "Austria", phone: "43" },
		{ code: "BO", label: "Bolivia", phone: "591" },
	];

	const [selectedCountry, setSelectedCountry] = useState(
		countriese.find((c) => c.code === "BO") // Bolivia por defecto
	);

	return (
		<Autocomplete
			size="small"
			id="country-select-demo"
			sx={{
				"width": 150,
				"& .MuiInputBase-root": {
					backgroundColor: "#fff",
					fontSize: 12,
				},
			}}
			options={countriese}
			value={selectedCountry}
			onChange={(event, newValue) => {
				setSelectedCountry(newValue);
			}}
			autoHighlight
			// Muestra solo el código telefónico en el input
			getOptionLabel={(option) => `+ ${option.phone}`}
			// Filtrado rápido por code, label o phone
			filterOptions={(options, { inputValue }) => {
				const inputLower = inputValue.toLowerCase();
				return options.filter(
					(option) =>
						option.code.toLowerCase().includes(inputLower) ||
						option.label.toLowerCase().includes(inputLower) ||
						option.phone.includes(inputLower)
				);
			}}
			// Lista de sugerencias, cada item con su bandera
			renderOption={(props, option) => (
				<Box component="li" sx={{ "& > img": { mr: 2, flexShrink: 0 } }} {...props}>
					<img
						loading="lazy"
						width="15"
						srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
						src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
						alt=""
					/>
					({option.code}) +{option.phone}
				</Box>
			)}
			// Campo de texto: añadimos la bandera al inicio (startAdornment)
			renderInput={(params) => (
				<TextField
					{...params}
					placeholder="+591"
					inputProps={{
						...params.inputProps,
						autoComplete: "new-password", // Evita autocompletado del navegador
					}}
					// Aquí agregamos la bandera de selectedCountry como adorno
					InputProps={{
						...params.InputProps,
						startAdornment: selectedCountry ? (
							<>
								<img
									loading="lazy"
									width="18"
									style={{ marginRight: 8 }}
									src={`https://flagcdn.com/w20/${selectedCountry.code.toLowerCase()}.png`}
									srcSet={`https://flagcdn.com/w40/${selectedCountry.code.toLowerCase()}.png 2x`}
									alt=""
								/>
								{params.InputProps.startAdornment}
							</>
						) : (
							params.InputProps.startAdornment
						),
					}}
				/>
			)}
		/>
	);
};
